<template>
  <div class="patient-transferred-check">
    <el-card>
      <div>
        <help-tooltip v-if="warnings.length" type="warning">
          <span v-for="warning in warnings" :key="warning.message">{{ warning.message }}</span>
        </help-tooltip>
        If patient has been transferred
      </div>
    </el-card>
  </div>
</template>

<script>
import get from 'lodash/get';
import uniqBy from 'lodash/uniqBy';
import HelpTooltip from '../../common/components/HelpTooltip';

export default {
  name: 'patient-transferred-check',
  components: {
    HelpTooltip,
  },
  props: ['readonly', 'emitter', 'ikey', 'getData', 'putData', 'control'],
  data() {
    return {
      state: {
      },
    };
  },
  computed: {
    warnings() {
      if (!this.emitter.$store) {
        return [];
      }
      const warnings = get(
        this.emitter.$store.getters['validation/visibleWarningsByFieldAndId'],
        `caseLogicDescription.${this.control.parent.id}`,
        [],
      ).filter(warning => warning.metadata && warning.metadata.checkKey === this.ikey);

      return uniqBy(warnings, 'message');
    },
  },
  mounted() {
    this.emitter.trigger('process', this.control);
    this.update();
  },
  methods: {
    update() {
      this.putData(this.ikey, {
        type: 'TRANSFER',
        id: 'TRANSFER',
        operator: 'EQUAL',
        value: true,
      });
      this.emitter.trigger('process', this.control);
    },
  },
};
</script>

<style scoped>
.patient-transferred-check, .el-card {
  width: 100%;
  color: black;
}
.help-tooltip {
  margin-right: 10px;
}
</style>
